<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">
        <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
          <a-col :span="12">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              :label="language['messageTemplatemanagement.templateCode']"
              style="margin-right: -35px"
              prop="templateCode"
            >
              <a-input
                :disabled="disable"
                :placeholder="language['common.pleaseInput']+language['messageTemplatemanagement.templateCode']"
                v-model="model.templateCode"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              :label="language['messageTemplatemanagement.templateType']"
              prop="templateType">
              <j-dict-select-tag  @change="handleChangeTemplateType" :triggerChange="true" dictCode="msgType" v-model="model.templateType" :placeholder="language['common.pleaseChoose']+language['messageTemplatemanagement.templateType']">
              </j-dict-select-tag>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="24" >
          <a-col :span="12" >
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              :label="language['messageTemplatemanagement.templateName']"
              prop="templateName"
              style="margin-right: -35px"
              >
              <a-input
                :placeholder="language['common.pleaseInput']+language['messageTemplatemanagement.templateName']"
                v-model="model.templateName"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12" >
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              :label="language['premission.applicationName']"
              prop="applicationCode"
              >
              <a-select allowClear v-model="model.applicationCode" :placeholder="language['column.pleaseChoose']+language['premission.applicationName']" :disabled="actionType==='edit'||$store.getters.application.applicationType !== 'platform'">
                <a-select-option v-for="(application,index) in applicationList" :key="index.toString()" :value="application.applicationCode">
                  {{ application.applicationName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="24" v-if="!useEditor">
          <a-col :span="24" pull="4">
            <a-form-model-item

              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              :label="language['messageTemplatemanagement.templateContent']"
              prop="templateContent"
              style="margin-left: 4px;width: 126%">
              <a-textarea :placeholder="language['common.pleaseInput']+language['messageTemplatemanagement.templateContent']" v-model="model.templateContent" :autosize="{ minRows: 8, maxRows: 8 }" :maxLength="800"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="24" v-if="useEditor">
          <a-col :span="24" pull="4">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              :label="language['messageTemplatemanagement.templateContent']"
              prop="templateContent"
              style="margin-left: 4px;width: 126%">
              <j-editor  v-model="templateEditorContent"></j-editor>
            </a-form-item>
          </a-col>
        </a-row>

      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>
  import {httpAction} from '@/api/manage'
  import { get, pick } from 'lodash';
  import { duplicateCheck } from '@/api/api'
  import JEditor from '@/components/jeecg/JEditor'

  export default {
    name: "SysMessageTemplateModal",
    components:{
      JEditor
    },
    data() {
      return {
        title: "",
        visible: false,
        disable: true,
        model: {},
        labelCol: {
          xs: {span: 24},
          sm: {span: 5},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16},
        },
        confirmLoading: false,
        // form: this.$form.createForm(this),
        /*validatorRules: {
          username:[{required: true, message: '请输入用户账号!'},
            {validator: this.validateUsername,}],
        templateCode: {rules: [{required: true, message: '请输入模板CODE!' },{validator: this.validateTemplateCode}]},
        templateName: {rules: [{required: true, message: '请输入模板标题!'}]},
        templateContent: {rules: []},
        templateType: {rules: [{required: true, message: '请输入模板类型!'}]},
        applicationCode:{rules: [{required: true, message: '请选择应用!'}]},
        },*/
        validatorRules: {
          templateCode: [{required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['messageTemplatemanagement.templateCode'] },{validator: this.validateTemplateCode}],
          templateName: [{required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['messageTemplatemanagement.templateName']}],
          templateType: [{required: true, message: this.$store.getters.language['common.pleaseChoose']+this.$store.getters.language['messageTemplatemanagement.templateType']}],
          applicationCode:[{required: true, message: this.$store.getters.language['column.pleaseChoose']+this.$store.getters.language['premission.applicationName']}],
          templateContent:[{required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['messageTemplatemanagement.templateContent']}],
        },
        url: {
          add: "/sys/message/sysMessageTemplate/add",
          edit: "/sys/message/sysMessageTemplate/edit",
        },
        useEditor:false,
        templateEditorContent:"",
        application:{},
        applicationList:[],
        actionType:'',
      }
    },
    created() {
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      initAllApplications(){
        httpAction("/sys/sysBmApplication/queryList", "", "get").then((res) => {
          if (res.success) {
            this.applicationList = res.result;
          }
        })
      },
      add(application) {
        this.disable = false;
        this.edit({applicationCode:this.$store.getters.applicationCode},application);
      },
      edit(record,application) {
        this.application = application;
        // this.form.resetFields();
        this.model = Object.assign({}, record);
        this.useEditor = (record.templateType==2 || record.templateType==4)
        if(this.useEditor){
          this.templateEditorContent=record.templateContent
        }else{
          this.templateEditorContent=''
        }
        this.visible = true;
        /*this.$nextTick(() => {
          if(this.useEditor){
            this.form.setFieldsValue(pick(this.model, 'templateCode', 'templateName', 'templateTestJson', 'templateType'))
          }else{
            this.form.setFieldsValue(pick(this.model, 'templateCode', 'templateContent', 'templateName', 'templateTestJson', 'templateType'))
          }
        });*/
        console.log("+++++++++++++++++++++"+this.model.applicationCode)
        this.initAllApplications();
      },
      close() {
        this.$emit('close');
        this.visible = false;
        this.disable = true;
      },
      handleOk() {
        // this.model.templateType = this.templateType;
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            if(this.templateEditorContent && this.templateEditorContent.length > 2000000){
              this.$message.warning(this.language['common.warning.contentTooLong']);
              return;
            }
            let formData = this.model;
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
              // formData.applicationCode = this.applicationCode;
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }

            //时间格式化

            if(this.useEditor){
              formData.templateContent=this.templateEditorContent
            }
            console.log(formData)
            httpAction(httpurl, formData, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })


          }
        })
      },
      validateTemplateCode(rule, value, callback){
        var params = {
          tableName: "sys_sms_template",
          fieldName: "template_code",
          fieldVal: value,
          dataId: this.model.id
        }
        duplicateCheck(params).then((res)=>{
          if(res.success){
            callback();
          }else{
            callback(res.message);
          }
        })

      },
      validateTemplateContent(rule, value, callback){
        if(value.length>800){
          callback(this.language["system.lengthExceedslimit"]);
        }
      },
      handleCancel() {
        this.close()
      },
      handleChangeTemplateType(value){
        //如果是邮件类型那么则改变模板内容是富文本编辑器
        this.useEditor = (value==2 || value==4)
      }

    }
  }
</script>

<style scoped>

</style>